export const CLIENT_STATUSES = [
  { value: "preapproved", label: "Preapproved — Ready to Place Offers", short: "Preapproved" },
  { value: "fully_approved", label: "Fully Approved — Ready to Place Offers", short: "Fully Approved" },
];

export const STATUS_META = {
  preapproved: {
    label: "Preapproved — Ready to Place Offers",
    short: "Preapproved",
    cls: "text-sky-300 border-sky-300/40 bg-sky-400/10",
    dot: "bg-sky-300",
  },
  fully_approved: {
    label: "Fully Approved — Ready to Place Offers",
    short: "Fully Approved",
    cls: "text-emerald-300 border-emerald-300/40 bg-emerald-400/10",
    dot: "bg-emerald-300",
  },
};

export const statusMeta = (s) => STATUS_META[s] || STATUS_META.preapproved;
